import { Box, Typography } from '@dtx-company/design-system/src'
import { Circle } from '@mui/icons-material'
import { MarketingPageRoutes, Routes } from '@dtx-company/true-common/src/constants/routes'
import React from 'react'

export const PrivacyTOSFooter: React.FC = () => {
  return (
    <Box
      sx={theme => ({
        color: 'onSurface.secondary',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '.MuiTypography-root': {
          fontWeight: 500,
          fontSize: '0.75rem'
        },
        textDecorationColor: 'onSurface.secondary',
        textDecoration: 'underline'
      })}
    >
      <a rel="noopener noreferrer" target="_blank" href={Routes.PRIVACY_POLICY}>
        <Typography component="span" color="onSurface.secondary">
          Privacy Policy
        </Typography>
      </a>
      <Box
        sx={theme => ({
          width: theme.spacing(1.25),
          height: theme.spacing(1.25),
          marginX: theme.spacing(4),
          display: 'flex',
          alignItems: 'center'
        })}
      >
        <Circle sx={{ height: '100%', width: '100%' }} />
      </Box>
      <a rel="noopener noreferrer" target="_blank" href={MarketingPageRoutes.TERMS_OF_SERVICE}>
        <Typography component="span" color="onSurface.secondary">
          Terms of Service
        </Typography>
      </a>
    </Box>
  )
}
